var React = require('react');

function DownloadRound (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M5.375 6.875L8 9.49931L10.625 6.875","stroke":"#1F1F1F","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M8 2.5L8 9.49816","stroke":"black","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M13 13.5L3 13.5","stroke":"black","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

DownloadRound.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = DownloadRound;

DownloadRound.default = DownloadRound;
